export default __webpack_public_path__ + "static/media/Tags.c384983b.svg";